import { Navigate } from 'react-router-dom'

import { Role } from '../domain/role.enum'
import { useAppSelector } from '../store'

const mapper: Record<Role, string | undefined> = {
  [Role.Administrator]: '/dashboard/summary',
  [Role.FinanceManager]: '/register/release-payment-files',
  [Role.CheckRunManager]: '/dashboard/summary',
  [Role.CheckRun]: '/dashboard/summary',
  [Role.AccountExecutive]: '/register/check-registers',
  [Role.AccountAdministrator]: '/register/check-registers',
  [Role.AccountManager]: '/register/check-registers',
  [Role.CallCenter]: '/register/check-registers',
  [Role.Claims]: '/register/check-registers',
  [Role.EPayablesManager]: '/dashboard/summary',
  //TODO: Update to proper AP/AR locations once frontend is ready
  [Role.AccountsPayable]: '/premium/groups',
  [Role.AccountsReceivable]: '/premium/groups'
}

export function DefaultRedirect(): JSX.Element | null {
  const user = useAppSelector(state => state.app.user)
  const role = user.roles[0]

  const isReady = useAppSelector(state => state.app.isReady)

  if (!isReady) {
    return null
  }

  const to =
    typeof role === 'string' ? (mapper[role] ?? '/dashboard/summary') : '/dashboard/summary'

  return <Navigate to={to} />
}
